import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddress } from '../shared/interfaces/address';
import { IProfile } from '../shared/interfaces/profile';
import { ProfileService } from '../shared/services/profile.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  profile: IProfile;
  address: IAddress;
  whatsappApi: string;
  instagramUrl: string = environment.instagramUrl;
  facebookUrl: string = environment.facebookUrl;
  curriculoUrl: string = environment.curriculoUrl;
  email: string = environment.email;
  
  constructor(private profileService: ProfileService) { }

  ngOnInit(): void {
    this.profile = this.profileService.getProfile();
    this.address = this.profile.address;
    this.whatsappApi = environment.whatsappApiUrl + this.address.whatsAppNumber;
  }

}
